import { useContext } from "react"
import {
	Alert,
	Box,
	CircularProgress,
	Dialog,
	IconButton,
} from "@mui/material"
import { MdClose } from "react-icons/md"

import { ContextoGeral } from "../../../contextos/ContextoGeral"
import GestaoVagaMensagem from "./GestaoVagaMensagem"
import GestaoVagaCidadeDistancia from "./GestaoVagaCidadeDistancia.jsx"
import GestaoVagaEnderecoGpsRow from "./GestaoVagaEnderecoGpsRow.jsx"
import GestaoVagaFilaDetalheParticipacao from "./GestaoVagaFilaDetalheParticipacao.jsx"
import GestaoVagaFilaDetalheTopo from "./GestaoVagaFilaDetalheTopo.jsx"
import {
	aplicarRotuloVagaTexto,
	resolverRotulosGestaoVaga,
} from "./gestaoVagaRotuloUtil.js"

export default function GestaoVagaDetalheSheet({
	aberto,
	carregando,
	vaga,
	destaqueIngressoHoje = null,
	onFechar,
	onIngressoAtualizado,
	somenteLeitura = false,
	/** Detalhes abertos pela tela Fila: grade de dias e titularidade */
	participacaoFila = false,
	onAtualizarLocalizacaoFila,
	atualizandoGeoFila = false,
	onErroGpsFila,
	onAtualizarLocalizacao,
	atualizandoLocalizacao = false,
	rotulos,
}) {
	const atualizarGeo =
		onAtualizarLocalizacaoFila ?? onAtualizarLocalizacao
	const atualizandoGeo = atualizandoGeoFila || atualizandoLocalizacao
	const { dados } = useContext(ContextoGeral)
	const txt = (texto) =>
		aplicarRotuloVagaTexto(texto, rotulos ?? resolverRotulosGestaoVaga())

	return (
		<Dialog
			fullScreen
			open={aberto}
			onClose={onFechar}
			className="gv-detalhe-sheet"
		>
			<div className="gv-detalhe-sheet__layout">
				<div className="gv-detalhe-sheet__header">
					<span className="gv-detalhe-sheet__titulo">
						{vaga?.titulo || txt("Detalhes da vaga")}
					</span>
					<IconButton aria-label="Fechar" onClick={onFechar} size="small">
						<MdClose size={24} />
					</IconButton>
				</div>

				<div className="gv-detalhe-sheet__scroll gv-app">
					{carregando ? (
						<Box className="flex justify-center py-12">
							<CircularProgress />
						</Box>
					) : vaga?.erro ? (
						<Alert severity="error" className="gv-alert-linha-toda">{vaga.erro}</Alert>
					) : vaga ? (
						<>
							<GestaoVagaCidadeDistancia
								className="mb-3"
								cidadeEstado={
									vaga.cidadeEstado || vaga.mensagem?.cidadeEstado || ""
								}
								distanciaTexto={
									vaga.distanciaTexto || vaga.mensagem?.distanciaTexto || ""
								}
								onAtualizarLocalizacao={atualizarGeo}
								atualizandoLocalizacao={atualizandoGeo}
							/>
							<GestaoVagaEnderecoGpsRow vaga={vaga} className="mb-3" />
							{participacaoFila ? (
								<GestaoVagaFilaDetalheTopo
									vaga={vaga}
									onAtualizarLocalizacao={atualizarGeo}
									atualizandoGeo={atualizandoGeo}
									onErroGps={onErroGpsFila}
								/>
							) : null}
							<div className="gv-detalhe-sheet__card">
								{participacaoFila ? (
									<GestaoVagaFilaDetalheParticipacao vaga={vaga} />
								) : (
									<GestaoVagaMensagem
										vaga={vaga}
										dados={somenteLeitura ? null : dados}
										somenteLeitura={somenteLeitura}
										destaqueIngressoHoje={destaqueIngressoHoje}
										rotulos={rotulos}
										onIngressoAtualizado={(vagaAtualizada) => {
											onIngressoAtualizado?.(vagaAtualizada)
										}}
									/>
								)}
							</div>
						</>
					) : null}
				</div>
			</div>
		</Dialog>
	)
}
